/** Разбивает textarea на значения: сплит по строкам + трим, БЕЗ фильтрации.
 * Пустые строки и дубликаты отправляются как есть — сервер тримит/дедуплицирует
 * (DO NOTHING), итог imported/skipped совпадает с введённым (спека §7). */
export const parseImportValues = (raw: string): string[] =>
  raw.split(/\r?\n/).map((s) => s.trim())

/** Число непустых значений — клиентская валидация лимита DTO 1–10000. */
export const countImportValues = (values: string[]): number =>
  values.filter((v) => v !== "").length
